import Icon from '../../../components/AppIcon';

const BizznetNotifications = ({ notifications }) => {
  const getNotificationIcon = (type) => {
    const iconConfig = {
      'withdrawal_rejected': { icon: 'XCircle', color: 'text-error' },
      'withdrawal_approved': { icon: 'CheckCircle', color: 'text-success' },
      'withdrawal_processing': { icon: 'Clock', color: 'text-warning' },
      'recommendation': { icon: 'AlertTriangle', color: 'text-warning' },
      'info': { icon: 'Info', color: 'text-primary' }
    };
    return iconConfig?.[type] || iconConfig?.info;
  };

  const getNotificationBg = (type) => {
    const bgConfig = {
      'withdrawal_rejected': 'bg-error/10 border-error/30',
      'withdrawal_approved': 'bg-success/10 border-success/30',
      'withdrawal_processing': 'bg-warning/10 border-warning/30',
      'recommendation': 'bg-warning/10 border-warning/30',
      'info': 'bg-primary/10 border-primary/30'
    };
    return bgConfig?.[type] || bgConfig?.info;
  };

  return (
    <div className="bg-card rounded-lg shadow-card p-6 border border-border">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
          <Icon name="Bell" size={20} color="white" />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-foreground">Notificaciones BIZZNET</h2>
          <p className="text-sm text-muted-foreground">Actualizaciones sobre tus retiros y recomendaciones</p>
        </div>
      </div>

      <div className="space-y-4">
        {notifications?.length === 0 ? (
          <div className="text-center py-12 text-muted-foreground bg-muted/30 rounded-lg">
            <Icon name="BellOff" size={48} className="mx-auto mb-3 opacity-50" />
            <p className="font-medium">No tienes notificaciones</p>
            <p className="text-xs mt-1">Las actualizaciones sobre tus retiros aparecerán aquí</p>
          </div>
        ) : (
          notifications?.map((notification) => {
            const iconConfig = getNotificationIcon(notification?.type);
            const bgClass = getNotificationBg(notification?.type);
            
            return (
              <div
                key={notification?.id}
                className={`p-4 rounded-lg border ${bgClass} transition-all hover:shadow-md`}
              >
                <div className="flex items-start gap-4">
                  <div className={`flex-shrink-0 ${iconConfig?.color}`}>
                    <Icon name={iconConfig?.icon} size={24} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-2 mb-2">
                      <h3 className="font-semibold text-foreground">{notification?.title}</h3>
                      <span className="text-xs text-muted-foreground whitespace-nowrap">
                        {notification?.date}
                      </span>
                    </div>
                    <p className="text-sm text-foreground/80 mb-3">{notification?.message}</p>
                    
                    {notification?.observation && (
                      <div className="bg-background/50 p-3 rounded-md mb-3">
                        <p className="text-xs font-medium text-foreground mb-1">Observación del Administrador:</p>
                        <p className="text-sm text-muted-foreground">{notification?.observation}</p>
                      </div>
                    )}
                    
                    {notification?.recommendation && (
                      <div className="bg-warning/5 border border-warning/20 p-3 rounded-md">
                        <div className="flex items-start gap-2">
                          <Icon name="Lightbulb" size={16} className="text-warning flex-shrink-0 mt-0.5" />
                          <div>
                            <p className="text-xs font-medium text-foreground mb-1">Recomendación:</p>
                            <p className="text-sm text-muted-foreground">{notification?.recommendation}</p>
                          </div>
                        </div>
                      </div>
                    )}
                    
                    {notification?.withdrawalId && (
                      <div className="mt-3 pt-3 border-t border-border/50">
                        <p className="text-xs text-muted-foreground">
                          ID de Retiro: <span className="font-mono font-medium text-foreground">{notification?.withdrawalId}</span>
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default BizznetNotifications;